export default __webpack_public_path__ + "static/fargevekting-3fargekombo-d2200e47b959c712b9ddd70edbb4c4a6.png";